import { render, staticRenderFns } from "./CustomeTable.vue?vue&type=template&id=351656a3&scoped=true&"
import script from "./CustomeTable.vue?vue&type=script&lang=js&"
export * from "./CustomeTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomeTable.vue?vue&type=style&index=0&id=351656a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351656a3",
  null
  
)

export default component.exports